import { getGeoCodeResults } from './getGeoCodeResults';

export const latLongToCountry = async (latitude: number, longitude: number) => {
  const geoCodeResults = await getGeoCodeResults({ latitude, longitude });

  const addressComponents = geoCodeResults.map(({ address_components }) => {
    return address_components[0];
  });
  const country = addressComponents.find(({ types }) => types[0] === 'country');

  return country?.short_name;
};
